import React, { useEffect, useState } from 'react';
import { makeStyles, Container } from '@material-ui/core';
import clsx from 'clsx';

// import components
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import ContentPage from '../components/Section/ContentPage';

const useStyles = makeStyles(() => ({
  root: {},
  container: {
    padding: '0 10px',
    paddingTop: '80px',
    minHeight: 'calc(100vh - 415px)',
    '@media (min-width: 1600px)': {
      maxWidth: '1440px',
    },
    '@media (max-width: 767px)': {
      padding: '30px 0 0',
    },
  },
}), 'system-error');

const SystemError = () => {
  const classes = useStyles();
  const [errorType, setErrorType] = useState('');
  useEffect(() => {
    const systemErrorCode = window.sessionStorage.getItem('SYSTEM_ERROR_CODE');
    if (systemErrorCode) setErrorType(` (TAM-${systemErrorCode})`);
    window.sessionStorage.removeItem('SYSTEM_ERROR_CODE');
  }, []);
  return (
    <div>
      <Header
        namePage="Trading Account Application"
        backLink={{ name: 'Back to OCBC.com', href: '/' }}
      />

      <Container className={clsx(classes.container, classes.widthMed3)}>

        <ContentPage
          title="System is currently unavailable"
          content={(
            <>
              <p>
                This error happened because of system exception
                {errorType}
                . Please try again later.
              </p>

              <p>If you have further enquiries, please call us at 1800 338 8688 (or +65 6338 8688 if overseas).</p>
            </>
          )}
        />
      </Container>
      <Footer />
    </div>
  );
};

export default SystemError;